module.exports = __webpack_public_path__ + "static/media/wordpress.11ee0136.png";